import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";

const WidgetOverlay = ({ buttonText }) => {
  return (
    <div className="overlay overlay-default">
      <Link to={`${global.applicationPath}/incidents`} className="btn">
        {buttonText}
      </Link>
    </div>
  );
};

WidgetOverlay.propTypes = {
  buttonText: PropTypes.string.isRequired
};

export default WidgetOverlay;



// WEBPACK FOOTER //
// ./src/dashboard/widgets/WidgetOverlay.js